import React, { Component } from 'react';
import Grid from '../../Utils/GridNDCR';

class NDDetalle extends Component{
    
    render(){
        const { loader, detalle } = this.props;
        return(
            <React.Fragment>
                {detalle &&
                    <Grid 
                        hover 
                        striped 
                        data={detalle} 
                        loading={loader} 
                        footer
                        headerStyle={ { background: 'black' } } 
                        //onSortChange={onSortChange} 
                    >
                    <TableHeaderColumn
                        isKey
                        dataField="codigo_visitador"
                        dataSort
                        width="50"
                        thStyle={ 
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Codigo
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="nombre_visitador"
                        dataSort
                        width="250"
                        thStyle={ 
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Nombre
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="salario"
                        width="100"
                        headerAlign="center"
                        dataAlign='right'
                        dataSort
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);
                            }
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Salario
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="comision"
                        width="100"
                        headerAlign="center"
                        dataAlign='right'
                        dataSort
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);
                            }
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Comisión
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="seguro_social"
                        width="100"
                        headerAlign="center"
                        dataAlign='right'
                        dataSort
                        dataFormat={(cell, row)=>{
                             if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);
                            }
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Aporte patronal
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="poliza_cr"
                        width="100"
                        headerAlign="center"
                        dataAlign='right'
                        dataSort
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);
                            }
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Poliza(ins)
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="aguinaldo"
                        width="100"
                        headerAlign="center"
                        dataAlign='right'
                        dataSort
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);
                            }
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Aguinaldo
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="total"
                        width="100"
                        headerAlign="center"
                        dataAlign='right'
                        dataSort
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Total débito
                    </TableHeaderColumn>
                </Grid>
                }
            </React.Fragment>
        );
    }
}

export default NDDetalle;
